import { createSelector } from 'reselect'
import { formatDateWithShortMonth } from '@offerzen/pinata'
import { getWorkHistory } from '../redux/modules/workHistory'

const sortWorkHistory = (a, b) => {
  if (a.still_there && b.still_there) {
    if (a.start > b.start) return -1
    if (a.start < b.start) return 1
    return 0
  }
  if (a.still_there && !b.still_there) return -1
  if (!a.still_there && b.still_there) return 1
  if (a.end > b.end) return -1
  if (a.end < b.end) return 1
  return 0
}

const metadataLabel = ({ start, end, still_there: stillThere }) => {
  let label = ''

  if (start) label += formatDateWithShortMonth(start, { includeDay: false })
  if (start && (end || stillThere)) label += ' to '
  if (stillThere) label += 'present'
  if (end && !stillThere) label += formatDateWithShortMonth(end, { includeDay: false })

  return label
}

const missingInformation = ({ isNew, company, position, start, end, still_there: stillThere }) =>
  !isNew && (!company || !position || !start || !(end || stillThere))

export const workHistoryList = createSelector([getWorkHistory], ({ data }) => {
  return data
    .map(workHistory => {
      let positionLabel = workHistory.position
      if (workHistory.company) {
        positionLabel += ` - ${workHistory.company}`
      }
      return {
        ...workHistory,
        formName: `workHistory[wh-${workHistory.id || workHistory.tempId}]`,
        positionLabel,
        companyLabel: workHistory.company,
        missingInformation: missingInformation(workHistory),
        metadataLabel: metadataLabel(workHistory),
        company: {
          label: workHistory.company,
        },
        position: {
          label: workHistory.position,
        },
        companiesSearchResults: workHistory.companiesSearchResults.map(company => ({
          value: company.id,
          label: company.text,
        })),
        rolesSearchResults: workHistory.rolesSearchResults.map(role => ({
          value: role.id,
          label: role.text,
        })),
      }
    })
    .sort((a, b) => sortWorkHistory(a, b))
})

export const anyRecordsMissingInformation = createSelector([getWorkHistory], ({ data }) =>
  data.some(workHistory => missingInformation(workHistory)),
)

export const currentlyEditingFormNames = createSelector([getWorkHistory], ({ data }) => {
  return data.filter(workHistory => !!workHistory.editing).map(workHistory => `workHistory[wh-${workHistory.id || workHistory.tempId}]`)
})

export const hasWorkHistoryRecords = createSelector([getWorkHistory], ({ data }) => {
  return data.filter(workHistory => !workHistory.isNew).length > 0
})

export const isAddingNewWorkHistory = createSelector([getWorkHistory], ({ data }) => {
  return data.filter(workHistory => workHistory.isNew).length > 0
})
